import { Button, InputAdornment, Stack, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import update from "../../../api/auth/organization/update";
import useAuthStore from "../../../stores/useAuthStore";
import WushTextField from "../../../components/form/WushTextField";
import useAlertStore from "../../../stores/useAlertStore";

export default function Taxes() {
  const { register, handleSubmit, control } = useForm();

  const { setOrganization, organization } = useAuthStore();

  const { setAlertMessage } = useAlertStore();

  const onSubmit = (values) => {
    update(organization.id, values, (response) => {
      setOrganization(response);
      setAlertMessage("Taxes updated successfully", "success");
    });
  };

  return (
    <Stack>
      <Stack mb={2}>
        <Typography variant="h4">
          Taxes
        </Typography>
        <Typography variant="body1">
          Configure your default taxes here. These settings will cascade to item categories and items you add. You can override these on a per-category and per-item basis.
        </Typography>
      </Stack>
      <Stack>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stack direction="row" gap={2} mb={2}>
            <Stack>
              <WushTextField
                inputStartAdornment={<InputAdornment position="start">%</InputAdornment>}
                formRegistration={register("state_tax_percent")}
                defaultValue={organization?.state_tax_percent}
                label="State Tax Percent"
              />
            </Stack>
            <Stack>
              <WushTextField
                inputStartAdornment={<InputAdornment position="start">%</InputAdornment>}
                formRegistration={register("local_tax_percent")} control={control}
                defaultValue={organization?.local_tax_percent}
                label="Local Tax Percent"
              />
            </Stack>
            <Stack>
              <WushTextField
                inputStartAdornment={<InputAdornment position="start">%</InputAdornment>}
                formRegistration={register("misc_tax_percent")} control={control}
                defaultValue={organization?.misc_tax_percent}
                label="Misc Tax Percent"
              />
            </Stack>
          </Stack>
          <Stack direction="row">
            <Button type="submit" variant="contained">Save</Button>
          </Stack>
        </form>
      </Stack>
    </Stack>
  );
}